import React, { useState } from 'react';
import './Header.css';
import NavLinks from '../Comman/Nav';
import logo from '../../Aseets/Img/Logo.png';
import World from '../../Aseets/Img/World.svg';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header>
        <button className='language_switcher'>
          <img className='icon' src={World} alt="" />
          <h5>AR</h5>
        </button>

        <nav className="nav">
          <ul className="nav__list">
            <NavLinks text="Home" to="/" />
            <NavLinks text="Booking" to="/booking" />
            <img className='header_logo' src={logo} alt="" />
            <NavLinks text="Exhibitors" to="/exhibitors" />
            <NavLinks text="Contact" to="/contact" />
          </ul>
        </nav>

        <button className='signup_button'>
          <span className="tab-left" />
          <h5>Sign up</h5>
          <span className="tab-right" />
        </button>

        <button
          className={`hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(prev => !prev)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </header>

  
      <nav className={`mobile-nav${menuOpen ? ' open' : ''}`}>
        <ul>
          <NavLinks text="Home" to="/" onClick={closeMenu} />
          <NavLinks text="Booking" to="/booking" onClick={closeMenu} />
          <NavLinks text="Exhibitors" to="/exhibitors" onClick={closeMenu} />
          <NavLinks text="Contact" to="/contact" onClick={closeMenu} />
        </ul>
        <button className='signup_button' onClick={closeMenu}>
          <span className="tab-left" />
          <h5>Sign up</h5>
          <span className="tab-right" />
        </button>
      </nav>
    </>
  );
};

export default Header;